module.exports = __webpack_public_path__ + "img/verve.b6a0c962.png";